import React from 'react'
import VisibilitySensor from '../VisibilitySensor'
import bg from './assets/images/bg.png'
import Content from '../Svolta/Content'
import { makeStyles } from '@material-ui/core/styles'
import FadeInHOC from '../FadeInHOC'
import { ColoriFormatiPageConfig } from '../../configuration'
import CombinationPicker from './CombinationPicker'
import { PickerProvider } from '../app/contexts/picket.context'
import AssignId from '../AssignId'

const styles = theme => ({
    root: {
        padding: '96px 10rem 120px 10rem',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        alignItems: 'center',
        flexDirection: 'column',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
            padding: '98px 1rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            padding: '40px 1rem',
            height: 'auto',
            justifyContent: 'flex-start'
        }
    },
    wrap: {
        background: `url(${bg})`
    }
})

const useStyles = makeStyles(styles)

export default function ColoriFormati() {
    const classes = useStyles()
    return (
        <div className={classes.wrap} >
            <PickerProvider>
                <div className={classes.root} >
                    <AssignId
                        absolute
                        y='0'
                        yMobile='-40px'
                        id={ColoriFormatiPageConfig.slug}
                    />
                    <FadeInHOC>
                        <Content
                            primaryText={ColoriFormatiPageConfig.content.primary}
                            secondaryText={ColoriFormatiPageConfig.content.secondary}
                        />
                    </FadeInHOC>
                    <VisibilitySensor index={4} />
                    <CombinationPicker />
                </div>
            </PickerProvider>
        </div>
    )
}
